const headerTitle: string = 'Подбор специалистов и их оценка компетенций'
const headerText: any = <>
  <p>Экспертность в подборе и оценке кадров для ЦТ. Отличный сервис. Быстрый и легкий рекрутинг.</p>
  <p>Мы оказываем квалифицированную помощь государственным органам власти в поиске, оценке и развитии «цифровых» кадров.</p>
</>
const headerLinkUrl: string = '#'
const headerBannerUrl: string = '/static/img/pages/selection-evaluation/header-image.png'

export { headerTitle, headerText, headerLinkUrl, headerBannerUrl }
